// extracted by mini-css-extract-plugin
export default {"testimonials":"Testimonials_testimonials__j6rS4","box":"Testimonials_box__SH3yA","img":"Testimonials_img__ORdc6"};